import types from "./types";
import { CALL_API } from "@cdkglobal/react-core-reduxapi";
import getAllRoles from "../api/getAllRoles";

export const actions = {
    fetchAllRoles: ({ accessToken }) => ({
        [CALL_API]: {
        ...getAllRoles(),
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
        types: [
            types.ALL_ROLES_GET_REQUEST,
            types.ALL_ROLES_GET_RECEIVE,
            types.ALL_ROLES_GET_ERROR,
        ],
        },
    }),
};